import React from 'react';
import PropTypes from 'prop-types';

import { formatCourseLevel } from '../../utils/courseLevel';
import usePreviewFeature from '../../hooks/usePreviewFeature';
import './course-name.style.scss';

const CourseName = ({ img, name, level, isViolet, isCenter, label }) => {

  const violetClass = isViolet ? 'course-name--bg-violet' : '';
  const centerClass = isCenter ? 'course-name--center' : '';

  const classes = [violetClass, centerClass].filter(Boolean).join(' ');
  const isRedesign = usePreviewFeature('courses-redesign');
  const levelText = isRedesign ? formatCourseLevel(level) : level;

  return (
    <div className={`course-name ${classes}`}>
      <img src={img} alt={name} width="1" height="1" decoding="async" />
      <div>
        <h3 className='course-name__title'>{name}</h3>
        {levelText && <p className="course-name__subtitle">{levelText}</p>}
      </div>
      {label && <span className='label label--violet'>{label}</span>}
    </div>
  );
};

CourseName.propTypes = {
  img: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  level: PropTypes.string,
  isViolet: PropTypes.bool,
  isCenter: PropTypes.bool,
  label: PropTypes.any,
};

export default CourseName;